module.exports = __webpack_public_path__ + "static/media/VPM_tablet_1.0176efa1.jpg";